import { AuthFetchWithResponse } from 'src/Types/api'
import { StatusCodes } from 'src/Libs/http-status-codes'
import { ManufacturerModel } from '../models'
import { ApiResult } from 'src/Libs/api'
import { AuthFetchError } from '@e3dc-react/shell/Types/api'
import { handleFetchError } from 'src/Libs/api/utils'
import { transformManufacturerDtoToModel } from '../transformer'
import { ManufacturerDto } from '../dto/manufacturer.dto'

export const fetchManufacturer = async (authFetch: AuthFetchWithResponse): Promise<ApiResult<ManufacturerModel[], AuthFetchError | Error>> => {
  try {
    const response = await authFetch<ManufacturerDto[]>({
      path: 'vehicles/vendors',
      method: 'GET',
      endpoint: process.env.REACT_APP_VEHICLES_ENDPOINT,
    })

    if (response.status === StatusCodes.OK) {
      const manufacturer = transformManufacturerDtoToModel(response.data)
      return new ApiResult<ManufacturerModel[], Error | AuthFetchError>(manufacturer)
    }

    return new ApiResult<ManufacturerModel[], Error | AuthFetchError>(null, true)
  } catch (error) {
    return handleFetchError<ManufacturerModel[]>(error)
  }
}
